module.exports = {
  selectLanguage: 'Select your language',
  tags: 'Tags',
  'tags.allTagsLink': 'Browse all tags',
  'tags.intro': 'Here you can find all the tags',
  'tags.blog.intro': 'Here you can find all the blog tags',
  'tags.pages.intro': 'Here you can find all the tags in the pages',
  'tags.nPostsTaggedWith': `{nPosts, number} {nPosts, plural,
      one {post}
      other {posts}
    } tagged with`,
  home: 'Home',
  about: 'About',
  artworks: 'Artworks',
  introduction: 'Introduction',
  portfolio: 'Portfolio',
  painting: 'Painting',
  'painting-new': '2019',
  'painting-oldest': 'oldest',
  sculpture: 'Sculpture',
  marble: 'Marble',
  wood: 'Wood',
  bronze: 'Bronze',
  'other-materials': 'Other materials',
  performance: 'Performance',
  performance01: 'Performance 01',
  performance02: 'Performance 02',
  performance03: 'Performance 03',
  performance04: 'Performance 04',
  'new-media': 'New media',
  augmented_reality: 'Augmented reality',
  interactivity: 'Interactivity',
  experimental: 'Experimental',
  blog: 'Blog',
  'blog-message': 'Last News',
  'keep-reading': 'Keep reading →',
  'find-out-more': 'Find out more...',
  followus: 'Follow Us: ',
  'info-sheet': 'Informative sheet',
  'info-sheet-title': 'Title: ',
  'info-sheet-year': 'Year: ',
  'info-sheet-technique': 'Technique: ',
  'info-sheet-dimensions': 'Dimensions: ',
  contact: 'Contacts',
  'contact.infos': 'Contact informations',
  'contact.fill-the-form': 'Fill the form to send a message',
  'contact.name': 'Name',
  'contact.surname': 'Surname',
  'contact.email': 'Email',
  'contact.subject': 'Subject',
  'contact.gender.male': 'Male',
  'contact.gender.female': 'Female',
  'contact.enquiry': 'Type of Enquiry',
  'contact.enquiry.a': 'Need to know more',
  'contact.enquiry.b': 'About art',
  'contact.enquiry.c': 'Want to say hello',
  'contact.message': 'Message',
  'contact.send': 'Send',
  not_found: '404 - Page Not Found',
  404: 'You are arrived to an unvailable page or you have missed the path...',
  copyright: '{year}, {company} - All rights reserved.',
  'menu-icon-message': 'Choose a section',
  'menu-icon-subtitle': 'Artworks sections',
  'menu-icon-painting': 'Painting',
  'menu-icon-sculpture': 'Sculpture',
  'menu-icon-performance': 'Performance',
  'menu-icon-interactivity': 'Interactivity',
  'home-page-showing-horoscope': 'Showing horoscope for {date}.',
  'home-page-showing-different-date': 'You can also choose a different date : ',
  'signs.aries': 'Aries',
  'signs.libra': 'Libra',
  'signs.taurus': 'Taurus',
  'signs.scorpio': 'Scorpio',
  'signs.gemini': 'Gemini',
  'signs.sagittarius': 'Sagittarius',
  'signs.cancer': 'Cancer',
  'signs.capricorn': 'Capricorn',
  'signs.leo': 'Leo',
  'signs.aquarius': 'Aquarius',
  'signs.virgo': 'Virgo',
  'signs.pisces': 'Pisces',
  'site.title': '7azzak.com',
  'site.title.description': 'What the stars Say About Your Fortune on {date}',
  'site.title.sign.description': '{sign} Horoscope for {date}',
  'site.description':
    'Daily Horoscope, astrology, fortune telling and more. Read through to know what your stars tell you!. We bring over horoscopes from various sites and get them here everyday.',
  'site.sign.description':
    '{sign} Horoscope for {date}. At 7azzak.com you can read {sign} Horoscope, astrology, fortune telling and more. Read through to know what your stars tell you!. We bring over horoscopes from various sites and get them here everyday..',
  'redirecting.title': 'Redirecting , one Sec',
  'redirecting.message': 'please wait while we redirect you to the correct page .... ',
};
